module.exports = __webpack_public_path__ + "img/9.11956ee6.png";